<div class="accessibility-dialogs-new-help-center">
    <div class="mon-dialog-header">
        <page-header [header]="'Accessibility help center' | translate"
                     panelClass="row"
                     panelLeftClass="mt-2"
                     panelRightClass="align-self-center">
            <page-header-content>
                <div class="d-flex justify-content-end align-items-center" *ngIf="canUseDecisionTree()">
                    <span class="label label-orange font-weight-500 mr-2 py-1" translate>
                        BETA
                    </span>
                    <span class="text-dark-grey mr-2" translate>
                        Get advice on how to handle this check
                    </span>
                    <button class="btn btn-border-radius emphasised-btn mr-3"
                            (click)="openDecisionTree()">
                        <span class="fas fa-question-circle fa-fw mr-1" aria-hidden="true"></span>
                        <span translate>Open Accessibility Decision Tree</span>
                    </button>
                </div>
            </page-header-content>
        </page-header>
    </div>
    <div class="mon-dialog-body">
        <div class="card panel-monsido-card mx-4 mt-4">
            <div class="card-header">
                <div class="row mt-1">
                    <div class="col-48 help-center-header d-flex align-items-center">
                        <mon-table-policy-type
                            class="pr-2 outer-t-smurf"
                            [color]="setTypeColor()"
                            [target]="check.result_type"
                            [isMobileCheck]="check.mobile"
                        >
                        </mon-table-policy-type>
                        <div class="pr-3 mr-auto">
                            <h2 [innerHTML]="check.name" class="my-0"></h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body pt-0">
                <div *ngIf="loading" class="text-center p-4">
                    <span class="fas fa-spinner fa-spin fa-3x"></span>
                </div>
                <div *ngIf="!loading">
                    <div class="mt-3" *ngIf="supportCenterCheck === null">
                        <h3 class="text-center" translate>
                            Information about this Check is not yet available
                        </h3>
                    </div>
                    <div *ngIf="supportCenterCheck !== null">
                        <div class="bg-light-grey row flex-row flex-nowrap px-1 py-2">
                            <div class="pl-2 pr-5">
                                <p class="text-bold" translate>Difficulty</p>
                                <p>{{getDifficultyTranslation}}</p>
                            </div>
                            <div class="pl-2 pr-5">
                                <p class="text-bold ml-1" translate>Guidelines</p>
                                <span class="inline-block mx-1 mb-2"
                                      [innerHTML]="guideline"
                                      *ngFor="let guideline of guidelines">
                                </span>
                            </div>
                            <div class="pl-2">
                                <p class="text-bold ml-1" translate>Tags</p>
                                <span class="tag inline-block mx-1 mb-2"
                                      [ngClass]="tag.class"
                                      *ngFor="let tag of tags">
                                    {{tag.translation}}
                                </span>
                            </div>
                        </div>
                        <div *ngIf="showSection(supportCenterCheck.short_description)">
                            <h3 class="mt-5" translate>Why is this an issue</h3>
                            <div class="mt-3 max-text-width">{{ supportCenterCheck.short_description }}</div>
                        </div>
                        <div class="mt-3 max-text-width" *ngIf="showSection(supportCenterCheck.description)" [innerHTML]="supportCenterCheck.description"></div>
                        <div class="mt-3 max-text-width" *ngIf="showSection(supportCenterCheck.quick_guide)">
                            <h3 class="mt-5" translate>Quick Guide</h3>
                            <div [innerHTML]="supportCenterCheck.quick_guide"></div>
                        </div>
                        <!-- TODO: Add Success Criteria back when #18478 is ready -->
<!--                        <div *ngIf="showSection(supportCenterCheck.success_criteria)" class="mb-3">-->
<!--                            <h3 class="mb-5" translate>Success Criteria</h3>-->
<!--                            <div [innerHTML]="supportCenterCheck.success_criteria"></div>-->
<!--                        </div>-->
                        <h3 class="mt-5" translate *ngIf="supportCenterCheck.pass_examples.length > 20 || supportCenterCheck.fail_examples.length > 20 ">Examples</h3>
                        <div class="row">
                            <div class="col col-md-24" *ngIf="supportCenterCheck.fail_examples.length > 20">
                                <p class="text-bold text-light-red" translate>Fail Example</p>
                                <div [innerHTML]="supportCenterCheck.fail_examples"></div>
                            </div>
                            <div class="col col-md-24" *ngIf="supportCenterCheck.pass_examples.length > 20">
                                <p class="text-bold text-green" translate>Pass Example</p>
                                <div [innerHTML]="supportCenterCheck.pass_examples"></div>
                            </div>
                        </div>
                        <div *ngFor="let otherSection of supportCenterCheck.others">
                            <h3>{{otherSection.title}}</h3>
                            <div class="max-text-width" [innerHTML]="otherSection.description"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
